module.exports = __webpack_public_path__ + "static/media/close-icon-brand-refresh.0ea732a2.svg";